<template>
  <div>
    <form-field-full-name
      label="Name"
      :entity="form"
      :validation-errors="validationErrors"
    ></form-field-full-name>

    <hr>
    <template v-if="isCreating">
      <h2 class="section_title">Contact Type (required)</h2>

      <form-field
        class="flex flex-wrap"
        :validation-errors="validationErrors.contact_type_ids"
      >
        <form-field-checkbox
          v-for="type in contactTypeBoxes"
          :key="type.id"
          class="contact_type--checkbox"
          :native-value="type.include"
          v-model="type.include"
          :label="type.label"
          size="is-small"
        ></form-field-checkbox>
      </form-field>

      <hr>
      <h2 class="section_title">Attach Tags</h2>

      <form-field-collection
        v-model="form.tags"
        :options="availableTags"
        field="label"
        placeholder="Select tag"
        icon="label"
        :validation-errors="validationErrors.tags"
      ></form-field-collection>
      <p class="tag_note">Note: Tags must be created via Contact Settings before attaching to a contact</p>

      <hr>
    </template>

    <form-field-phone
      label="Primary Phone"
      v-model="form.phone_1"
      :validation-errors="validationErrors.phone_1"
      help-text="Follow up sequences will send SMS messages to this number"
    ></form-field-phone>

    <form-field-phone
      label="Phone 2"
      v-model="form.phone_2"
      :validation-errors="validationErrors.phone_2"
    ></form-field-phone>

    <div
      v-show="showExtraNumbers"
      class="columns is-multiline my-0"
    >
      <form-field-phone
        class="column is-6"
        label="Phone 3"
        v-model="form.phone_3"
        :validation-errors="validationErrors.phone_3"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 4"
        v-model="form.phone_4"
        :validation-errors="validationErrors.phone_4"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 5"
        v-model="form.phone_5"
        :validation-errors="validationErrors.phone_5"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 6"
        v-model="form.phone_6"
        :validation-errors="validationErrors.phone_6"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 7"
        v-model="form.phone_7"
        :validation-errors="validationErrors.phone_7"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 8"
        v-model="form.phone_8"
        :validation-errors="validationErrors.phone_8"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 9"
        v-model="form.phone_9"
        :validation-errors="validationErrors.phone_9"
      ></form-field-phone>

      <form-field-phone
        class="column is-6"
        label="Phone 10"
        v-model="form.phone_10"
        :validation-errors="validationErrors.phone_10"
      ></form-field-phone>
    </div>

    <div class="flex flex-end mb-25">
      <button-link
        @click="toggleExtraNumberVisibility"
      >Show {{ showExtraNumbers ? 'Less' : 'More' }} Numbers
      </button-link>
    </div>

    <form-field-input
      label="Email Address"
      type="email"
      v-model="form.email_address"
      :validation-errors="validationErrors.email_address"
    ></form-field-input>

    <hr>

    <form-field-address
      :entity="form"
      :validation-errors="validationErrors"
      include-line2
      :line2-label="'Apt, Suite, Units, etc.'"
    ></form-field-address>

    <form-field-timezones
      :entity="form"
      :validation-errors="validationErrors"
    ></form-field-timezones>

    <!--    <form-field-input-->
    <!--        label="CustomFields"-->
    <!--        v-model="form.custom_fields"-->
    <!--        :validation-errors="validationErrors.custom_fields"-->
    <!--    ></form-field-input>-->
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {appendModal} from "../services/modals";
import dates from "../services/dates";
import DuplicateWarningModal from "../modules/duplicates/DuplicateWarningModal.vue";

export default {
  name: "ContactForm",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      showExtraNumbers: false,
      defaultForm: {
        market_id: this.$store.getters.market.id,
        first_name: "",
        last_name: "",
        phone_1: null,
        phone_2: null,
        phone_3: null,
        phone_4: null,
        phone_5: null,
        phone_6: null,
        phone_7: null,
        phone_8: null,
        phone_9: null,
        phone_10: null,
        email_address: "",
        street: "",
        line_2: "",
        city: "",
        state: "",
        postcode: "",
        timezone: dates.getLocalTimezone(),
        types: [],
        tags: [],
        custom_fields: [],
        is_callable: true,
        is_textable: true,
        is_mailable: true,
      },
    };
  },
  computed: {
    availableContactTypes() {
      return this.$store.getters.contactTypes;
    },
    contactTypeBoxes() {
      let boxes = [];

      this.availableContactTypes.forEach(type => {
        boxes.push({
          id: type.id,
          label: type.name,
          include: false
        });
      });

      return boxes;
    },
    availableTags() {
      return this.$store.getters.contactTags;
    },
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  methods: {
    toggleExtraNumberVisibility() {
      this.showExtraNumbers = !this.showExtraNumbers;
    },
    update() {
      return this.$api.contacts.update(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: "Contact was updated",
            type: "is-success"
          });

          this.$store.commit("events/toggleEvent", "reloadContactTable");
          return res;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors

            if (!!this.validationErrors.duplicate_contacts) {
              appendModal(
                DuplicateWarningModal,
                this,
                {
                  duplicateContacts: this.validationErrors.duplicate_contacts,
                  canAttachReplacementInstead: false,
                }
              )
            }
          }

          throw error;
        });
    },
    create() {
      let contactTypeIds = [];

      this.contactTypeBoxes.forEach(type => {
        if (type.include) {
          contactTypeIds.push(type.id);
        }
      });

      this.form.contact_type_ids = contactTypeIds;

      return this.$api.contacts.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Contact was created",
            type: "is-success"
          });

          this.$store.commit("events/toggleEvent", "reloadContactTable");
          return res;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors

            if (!!this.validationErrors.duplicate_contacts) {
              appendModal(
                DuplicateWarningModal,
                this,
                {
                  duplicateContacts: this.validationErrors.duplicate_contacts,
                  canAttachReplacementInstead: false,
                }
              )
            }
          }

          throw error
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.section_title {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.contact_type--checkbox {
  width: 50%;
  margin-bottom: 4px!important;
}

.no_types {
  font-style: italic;
}

.type_tag_line {
  margin: 0.75rem 0;
}

.tag_note {
  font-size: 0.875rem;
  color: $text-light;
  line-height: 1.2;
}
</style>
